// extracted by mini-css-extract-plugin
export default {"aboutMe":"AboutMe_aboutMe__mb8og"};